import FormReferences from '@/app/Survey/model/FormReferences';
import FormStateResponse from '@/dtos/FormStateResponse';
import BaseService from '@/services/BaseService';
import { FormStructure, IQuestions, IResponseAnswer, PartialAnswersToRemove } from '@/services/FormStructure';
import axios, { CancelTokenSource } from 'axios';
export interface FormComplete {
    id: number;
    formId: number;
    transactionId: number;
    completedAt: Date;
}

export default class FormService extends BaseService {
    private cancelSaveAnswerRequest: CancelTokenSource;

    public async validateFormAvailability(params: FormReferences): Promise<FormStateResponse> {
        return await this._get<FormStateResponse>(`forms/availability/`, params);
    }

    public async getFormById(id: number, transactionId?: number): Promise<FormStructure> {
        return await this._get<FormStructure>(`forms/${id}`, { transactionId });
    }

    public async saveAnswer(answers: IQuestions, token?: string, complete?: boolean): Promise<IResponseAnswer[]> {
        const response = await this._post(`forms/answers/`, { ...answers, token, complete });
        return response as IResponseAnswer[];
    }

    public async cancelableSaveAnswer(answers: IQuestions, token?: string): Promise<IResponseAnswer[]> {
        this.cancelSaveAnswerRequest = axios.CancelToken.source();
        const response = await this._post(`forms/answers/`, { ...answers, token }, this.cancelSaveAnswerRequest.token);
        return response as IResponseAnswer[];
    }

    public cancelSaveAnswer(): void {
        this.cancelSaveAnswerRequest?.cancel('Canceled');
    }

    public async deletePartialAnswers(answers: PartialAnswersToRemove): Promise<IResponseAnswer[]> {
        const response = await this._del(`forms/answers/partial`, answers);
        return response as IResponseAnswer[];
    }
}
